import {
  CLEAN_SESSIONS_DETAIL_ORDER_VINCULATION,
  CLEAN_SESSIONS_DETAIL_ORDER_VINCULATION_ERROR,
  SESSIONS_DETAIL_ORDER_VINCULATION,
  SESSIONS_DETAIL_ORDER_VINCULATION_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  response: undefined,
  status: undefined,
  state: undefined,
};

export default function orderVinculationSessionsDetailReducer(state = initialState, action) {
  switch (action.type) {
    case SESSIONS_DETAIL_ORDER_VINCULATION:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'success',
      };

    case SESSIONS_DETAIL_ORDER_VINCULATION_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_SESSIONS_DETAIL_ORDER_VINCULATION:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_SESSIONS_DETAIL_ORDER_VINCULATION_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
